import React from "react";
import { useApi } from "../../hooks/useApi";
import { Spinner } from "../../components/ui/basics";
import TipologieMansioneBlock from "./TipologieMansioneBlock";
import AreeBlock from "./AreeBlock";
import MansioniBlock from "./MansioniBlock";

export default function AreeMansioniSection() {
  const { data: regioni } = useApi("/normative/regioni");
  if (!regioni) return <Spinner />;
  return (
    <div className="space-y-4">
      <TipologieMansioneBlock />
      <AreeBlock regioni={regioni} />
      <MansioniBlock regioni={regioni} />
    </div>
  );
}
